import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.renamePOCustomField.editablePOCustomFieldTextField`

export default defineMessages({
  inputPlaceholder: {
    id: `${scope}.inputPlaceholder`,
    defaultMessage: 'Field description',
  },
  inputAriaLabel: {
    id: `${scope}.inputAriaLabel`,
    defaultMessage: 'Field description',
  },
  statusIconIdleAriaLabel: {
    id: `${scope}.statusIconIdleAriaLabel`,
    defaultMessage: 'Edit field description',
  },
  statusIconPendingAriaLabel: {
    id: `${scope}.statusIconPendingAriaLabel`,
    defaultMessage: 'Saving field description',
  },
  statusIconResolvedAriaLabel: {
    id: `${scope}.statusIconResolvedAriaLabel`,
    defaultMessage: 'Field description saved',
  },
  statusIconRejectedAriaLabel: {
    id: `${scope}.statusIconRejectedAriaLabel`,
    defaultMessage: 'Failed to save field description',
  },
})
